
namespace TabAurous.Inventory {

    @Serenity.Decorators.registerClass()
    export class BranchInLaborGrid extends Serenity.EntityGrid<BranchInLaborRow, any> {
        protected getColumnsKey() { return 'Inventory.BranchInLabor'; }
        protected getIdProperty() { return BranchInLaborRow.idProperty; }
        protected getInsertPermission() { return BranchInLaborRow.insertPermission; }
        protected getLocalTextPrefix() { return BranchInLaborRow.localTextPrefix; }
        protected getService() { return BranchInLaborService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }
    }
}